module.exports = __webpack_public_path__ + "img/love.7b99770c.png";